import { RECAPTCHA_VERSION } from "../../../packs/grecaptcha";
import { getMonthsNames, getYearsForNow, getDaysNumber } from "../../../js/utils/functions";
import { MonthsMapper } from "../mappers";
import { constants } from "../service";
import {
  createContentItem,
  updateContentItems,
  removeContentItem,
  updatePositions,
} from "../utils";

export const initialState = {
  loading: false,
  loadingAreas: false,
  loadingSoftwares: false,
  loadingAssociableCourses: false,
  loadingCourse: false,
  areaIds: [],
  softwareIds: [],
  associableCourses: [],
  id: null,
  name: "",
  contentItems: [],
  errorRequest: false,
  errorMessage: {},
  isImageLoading: false,
  isCoverLoading: false,
  isEmbedContentLoading: false,
  courseId: null,
  course: {},
  cover: null,
  isPublic: null,
  madeAt: null,
  url: null,
  client: null,
  clientUrl: null,
  agency: null,
  agencyUrl: null,
  months: MonthsMapper.hydrate(getMonthsNames()),
  years: getYearsForNow(),
  days: getDaysNumber(),
  reCaptchaToken: null,
  reCaptchaVersion: RECAPTCHA_VERSION.V3,
  sharedVisibility: true,
};

export default function projectsReducer(state = initialState, action) {
  if (!action.type) {
    return state;
  }

  switch (action.type) {
    case constants.GET_PROJECT:
      return { ...state, loading: true };

    case constants.GET_PROJECT_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        loading: false,
        ...data,
        courseId: data.course?.id,
      };
    }

    case constants.GET_PROJECT_ERROR:
      return { ...state, loading: false, errorRequest: true, errorMessage: action.error };

    case constants.GET_AREAS:
      return { ...state, loadingAreas: true };

    case constants.GET_AREAS_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        loadingAreas: false,
        ...data,
      };
    }

    case constants.GET_AREAS_ERROR:
      return { ...state, loadingAreas: false, errorRequest: true, errorMessage: action.error };

    case constants.GET_SOFTWARES:
      return { ...state, loadingSoftwares: true };

    case constants.GET_SOFTWARES_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        loadingSoftwares: false,
        ...data,
      };
    }

    case constants.GET_SOFTWARES_ERROR:
      return { ...state, loadingSoftwares: false, errorRequest: true, errorMessage: action.error };

    case constants.GET_ASSOCIABLE_COURSES:
      return { ...state, loadingAssociableCourses: true };

    case constants.GET_ASSOCIABLE_COURSES_SUCCESS: {
      const data = action.payload;
      return { ...state, loadingAssociableCourses: false, ...data };
    }

    case constants.GET_ASSOCIABLE_COURSES_ERROR: {
      return {
        ...state,
        loadingAssociableCourses: false,
        errorRequest: true,
        errorMessage: action.error,
      };
    }

    case constants.GET_COURSE:
      return { ...state, loadingCourse: true };

    case constants.GET_COURSE_SUCCESS: {
      const data = action.payload;
      const areas = state.areas?.length ? state.areas : data.areas;
      const areaIds = areas?.map(a => a.id);

      return {
        ...state,
        loadingCourse: false,
        course: data,
        courseId: data.id,
        areas,
        areaIds,
      };
    }

    case constants.GET_COURSE_ERROR: {
      return {
        ...state,
        course: {},
        courseId: null,
        loadingCourse: false,
        errorRequest: true,
        errorMessage: action.error,
      };
    }

    case constants.DELETE_PROJECT:
      return { ...state, loading: true };

    case constants.DELETE_PROJECT_SUCCESS:
      return state;

    case constants.DELETE_PROJECT_ERROR:
      return { ...state, loading: false, errorRequest: true, errorMessage: action.error };

    case constants.SET_PROJECT_STORE: {
      const { data } = action;
      return {
        ...state,
        ...data,
      };
    }

    case constants.SET_PROJECT:
      return {
        ...state,
        loading: true,
        errorRequest: false,
        errorMessage: {},
      };

    case constants.SET_PROJECT_SUCCESS: {
      return {
        ...state,
        loading: false,
        ...action.payload,
        isEmbedContentLoading: false,
        isImageLoading: false,
        isCoverLoading: false,
      };
    }

    case constants.SET_PROJECT_ERROR:
      return {
        ...state,
        loading: false,
        isEmbedContentLoading: false,
        isImageLoading: false,
        isCoverLoading: false,
        errorRequest: true,
        errorMessage: action.error,
      };

    case constants.SET_EMBED_START_LOADING:
      return {
        ...state,
        isEmbedContentLoading: true,
      };

    case constants.SET_EMBED_STOP_LOADING:
      return {
        ...state,
        isEmbedContentLoading: false,
      };

    case constants.SET_IMAGE_START_LOADING:
      return {
        ...state,
        isImageLoading: true,
      };

    case constants.SET_IMAGE_STOP_LOADING:
      return {
        ...state,
        isImageLoading: false,
      };

    case constants.SET_COVER_START_LOADING:
      return {
        ...state,
        isCoverLoading: true,
      };

    case constants.SET_COVER_STOP_LOADING:
      return {
        ...state,
        isCoverLoading: false,
      };

    case constants.CREATE_CONTENT_ITEM_STORE:
      return {
        ...state,
        contentItems: [
          ...state.contentItems,
          createContentItem(state.contentItems?.length || 0, action.elementType),
        ],
      };

    case constants.REMOVE_CONTENT_ITEM_STORE: {
      const updatedContentItems = removeContentItem(state.contentItems, action.elementId);
      return {
        ...state,
        contentItems: [...updatedContentItems],
      };
    }

    case constants.CHANGE_CONTENT_ITEM_STORE:
      return { ...state, contentItems: updateContentItems(action, state) };

    case constants.UPDATE_CONTENT_ITEMS_POSITION_STORE:
      return {
        ...state,
        contentItems: updatePositions(state.contentItems, action.contentItems),
      };

    case constants.SET_RECAPTCHA_VERSION_STORE:
      return {
        ...state,
        reCaptchaVersion: action.reCaptchaVersion,
      };

    default:
      return state;
  }
}
